<template>
  <div class="footer__mob">
    <div
      class="translation-svg-wrapper"
      @click="openTranslationModal"
    >
      <translation-svg />
    </div>

    <div v-if="isPCLogoShown" :style="rightStyle">
      <div class="text">
        {{ $t('powered_by') }}
      </div>

      <a
        href="https://corefy.com"
        target="_blank"
      >
        <svg
          width="67px"
          height="11px"
          viewBox="0 0 67 11"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>{{ $t('logo_footer') }}</title>
          <defs />

          <g
            id="Modal"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="01_mobile-views"
              transform="translate(-644.000000, -528.000000)"
            >
              <g
                id="w-basic"
                transform="translate(480.000000, 80.000000)"
              >
                <g
                  id="footer"
                  transform="translate(0.000000, 425.000000)"
                >
                  <g
                    id="logo-footer"
                    transform="translate(164.000000, 23.000000)"
                  >
                    <g>
                      <path
                        id="Fill-1"
                        d="M4.13559341,6.77042667 C4.65852473,6.77042667 4.92781319,6.50202667 4.92781319,5.98136 L4.92781319,2.08314333 C4.92781319,1.56247667 4.65852473,1.29407667 4.13559341,1.29407667 L3.31171429,1.29407667 C3.02641209,1.29407667 2.75712363,1.37309333 2.4876511,1.54652667 L1.48946154,2.19369333 L1.48946154,5.87099333 L2.4876511,6.51797667 C2.75712363,6.69141 3.02641209,6.77042667 3.31171429,6.77042667 L4.13559341,6.77042667 Z M1.48946154,7.29127667 L1.48946154,10.9999267 L0,10.9999267 L0,0.0629933333 L1.34699451,0.0629933333 L1.42614286,0.836476667 L2.15504396,0.34716 C2.4876511,0.110476667 2.86811538,-7.33333333e-05 3.32754396,-7.33333333e-05 L4.43672527,-7.33333333e-05 C5.72003297,-7.33333333e-05 6.41727473,0.71016 6.41727473,1.97277667 L6.41727473,6.09172667 C6.41727473,7.35434333 5.72003297,8.06457667 4.43672527,8.06457667 L3.32754396,8.06457667 C2.93143407,8.06457667 2.53514011,7.95402667 2.15504396,7.71734333 L1.48946154,7.29127667 Z"
                      />
                      <path
                        id="Fill-4"
                        d="M10.9168585,6.84937 C11.1703173,6.84937 11.4397898,6.77035333 11.7090783,6.59673667 L12.6439492,5.99705333 L12.6439492,4.35585333 L10.1246387,4.65560333 C9.57004808,4.71867 9.34824863,4.89228667 9.34824863,5.38160333 L9.34824863,6.18643667 C9.34824863,6.67575333 9.55421841,6.84937 10.0771497,6.84937 L10.9168585,6.84937 Z M12.0418695,7.65420333 C11.6299299,7.92242 11.2178063,8.06450333 10.7900371,8.06450333 L9.85516621,8.06450333 C8.6351772,8.06450333 7.89044643,7.44905333 7.89044643,6.29698667 L7.89044643,5.31853667 C7.89044643,4.24530333 8.55602885,3.62985333 9.88682555,3.48777 L12.6439492,3.17225333 L12.6439492,2.00423667 C12.6439492,1.48338667 12.3744766,1.21517 11.819886,1.21517 L10.3147788,1.21517 C9.76018819,1.21517 9.49071566,1.48338667 9.49071566,2.00423667 L9.49071566,2.50932 L8.0489272,2.50932 L8.0489272,2.06748667 C8.0489272,0.726036667 8.82531731,3.66666667e-05 10.2196168,3.66666667e-05 L12.0260398,3.66666667e-05 C13.3728503,3.66666667e-05 14.117581,0.726036667 14.117581,2.03577 L14.117581,8.00143667 L12.7866003,8.00143667 L12.7074519,7.21237 L12.0418695,7.65420333 Z"
                      />
                      <path
                        id="Fill-6"
                        d="M16.0033918,11 L16.0033918,9.72161667 L16.969922,9.72161667 C17.3027132,9.72161667 17.5403423,9.53223333 17.7146527,9.1377 L18.1107626,8.20655 L15.7182736,3.06166667 C15.5754385,2.79345 15.5121198,2.49351667 15.5121198,2.17781667 L15.5121198,0.0630666667 L17.0015813,0.0630666667 L17.0015813,2.0042 C17.0015813,2.25683333 17.0490703,2.49351667 17.1442324,2.7302 L18.8080044,6.47056667 L20.3607846,2.7302 C20.4557626,2.49351667 20.5032516,2.25683333 20.5032516,2.0042 L20.5032516,0.0630666667 L21.9452242,0.0630666667 L21.9452242,2.17781667 C21.9452242,2.39891667 21.8819055,2.69866667 21.7392544,3.06166667 L19.1089522,9.31131667 C18.6020346,10.5266333 18.189911,11 17.2393945,11 L16.0033918,11 Z"
                      />
                      <path
                        id="Fill-8"
                        d="M25.5073786,8.06454 C24.0655901,8.06454 23.3048456,7.30700667 23.3048456,5.85500667 L23.3048456,2.20942333 C23.3048456,0.757423333 24.0655901,7.33333333e-05 25.5073786,7.33333333e-05 L27.297972,7.33333333e-05 C28.6922714,7.33333333e-05 29.4686615,0.757423333 29.4686615,2.20942333 L29.4686615,2.73027333 L28.0108593,2.73027333 L28.0108593,2.11482333 C28.0108593,1.56244 27.7415709,1.29404 27.1869802,1.29404 L25.6181863,1.29404 C25.0635956,1.29404 24.7943071,1.56244 24.7943071,2.11482333 L24.7943071,5.94979 C24.7943071,6.50217333 25.0635956,6.77039 25.6181863,6.77039 L27.1869802,6.77039 C27.7415709,6.77039 28.0108593,6.50217333 28.0108593,5.94979 L28.0108593,5.16072333 L29.4686615,5.16072333 L29.4686615,5.85500667 C29.4686615,7.30700667 28.6922714,8.06454 27.297972,8.06454 L25.5073786,8.06454 Z"
                      />
                      <path
                        id="Fill-10"
                        d="M36.7895343,6.81028333 C37.3027102,6.81028333 37.598136,6.49458333 37.598136,5.98968333 L37.598136,2.09146667 C37.598136,1.53908333 37.3338173,1.27068333 36.7895343,1.27068333 L33.2335646,1.27068333 C32.6892816,1.27068333 32.4247788,1.53908333 32.4247788,2.09146667 L32.4247788,5.98968333 C32.4247788,6.54188333 32.6892816,6.81028333 33.2335646,6.81028333 L36.7895343,6.81028333 Z M33.1247816,8.07271667 C31.7094986,8.07271667 30.9631113,7.31536667 30.9631113,5.86336667 L30.9631113,2.21778333 C30.9631113,0.765783333 31.7094986,0.00825 33.1247816,0.00825 L36.8985014,0.00825 C38.2824931,0.00825 39.0599876,0.765783333 39.0599876,2.21778333 L39.0599876,5.86336667 C39.0599876,7.31536667 38.2824931,8.07271667 36.8985014,8.07271667 L33.1247816,8.07271667 Z"
                      />
                      <path
                        id="Fill-12"
                        d="M42.2950201,8.001455 L40.8055585,8.001455 L40.8055585,0.0631216667 L42.152369,0.0631216667 L42.247531,1.04157167 L43.0872398,0.347105 C43.3881876,0.110421667 43.7684679,5.5e-05 44.2597398,5.5e-05 L45.4007646,5.5e-05 L45.4007646,1.29402167 L44.3232426,1.29402167 C44.0221107,1.29402167 43.7368085,1.37303833 43.4991794,1.546655 L42.2950201,2.55663833 L42.2950201,8.001455 Z"
                      />
                      <path
                        id="Fill-14"
                        d="M47.6349201,3.251105 L50.9466343,3.251105 L50.9466343,2.02002167 C50.9466343,1.46763833 50.6771618,1.19942167 50.1227552,1.19942167 L48.4587992,1.19942167 C47.9043926,1.19942167 47.6349201,1.46763833 47.6349201,2.02002167 L47.6349201,3.251105 Z M52.3886069,5.91823833 C52.3886069,7.322755 51.6120327,8.06452167 50.2019036,8.06452167 L48.3638212,8.06452167 C46.9218486,8.06452167 46.1614723,7.30698833 46.1614723,5.85498833 L46.1614723,2.209405 C46.1614723,0.757405 46.9218486,5.5e-05 48.3638212,5.5e-05 L50.2019036,5.5e-05 C51.6120327,5.5e-05 52.3886069,0.757405 52.3886069,2.209405 L52.3886069,4.434705 L47.6349201,4.434705 L47.6349201,6.04437167 C47.6349201,6.596755 47.9043926,6.865155 48.4587992,6.865155 L50.1067415,6.865155 C50.6613321,6.865155 50.9308047,6.596755 50.9308047,6.04437167 L50.9308047,5.50793833 L52.3886069,5.50793833 L52.3886069,5.91823833 Z"
                      />
                      <polygon
                        id="Fill-16"
                        points="55.4857555 8.0014 56.975217 8.0014 56.975217 0.0630666667 55.4857555 0.0630666667"
                      />
                      <path
                        id="Fill-18"
                        d="M64.5722992,6.81028333 C65.085475,6.81028333 65.3809008,6.49458333 65.3809008,5.98968333 L65.3809008,2.09146667 C65.3809008,1.53908333 65.1163981,1.27068333 64.5722992,1.27068333 L61.0163294,1.27068333 C60.4718624,1.27068333 60.2075437,1.53908333 60.2075437,2.09146667 L60.2075437,5.98968333 C60.2075437,6.54188333 60.4718624,6.81028333 61.0163294,6.81028333 L64.5722992,6.81028333 Z M60.9073624,8.07271667 C59.4922635,8.07271667 58.7458761,7.31536667 58.7458761,5.86336667 L58.7458761,2.21778333 C58.7458761,0.765783333 59.4922635,0.00825 60.9073624,0.00825 L64.6810821,0.00825 C66.0650739,0.00825 66.8427525,0.765783333 66.8427525,2.21778333 L66.8427525,5.86336667 C66.8427525,7.31536667 66.0650739,8.07271667 64.6810821,8.07271667 L60.9073624,8.07271667 Z"
                      />
                      <polygon
                        id="Fill-19"
                        points="34.3835165 4.66601667 35.6395824 4.66601667 35.6395824 3.41495 34.3835165 3.41495"
                      />
                      <polygon
                        id="Fill-20"
                        points="62.1778407 4.66601667 63.4107143 4.66601667 63.4107143 3.41495 62.1778407 3.41495"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import TranslationSvg from "@/components/svg/Translation";
import {mapState} from 'vuex';

export default {
  components: { TranslationSvg },
  computed: {
    ...mapState(['UI'], 'customThemeOptions'),

    isPCLogoShown() {
      return !(!(this.customThemeOptions || {}).PСLogo)
    },

    rightStyle() {
      return {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginRight: "20px"
      };
    }
  },

  methods: {
    openTranslationModal() {
      this.$bus.$emit("LangDialogToggle", true);
    }
  }
};
</script>


<style lang="scss" scoped>
.footer {
  &__mob {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 11px;
    font-weight: 500;
    line-height: 2.18;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    justify-content: space-between;

    .translation-svg-wrapper {
      width: 24px;
      height: 24px;
      margin-left: 20px;
      cursor: pointer;
    }

    .text {
      margin-right: 5px;
      margin-top: -1px;
      box-sizing: border-box;
    }

    a {
      display: flex;
      text-decoration: none;
      box-sizing: border-box;

      &:hover svg path {
        fill: #0006ff;
      }

      &:hover svg path:nth-last-child(3),
      &:hover svg polygon {
        fill: #ffd400;
      }
    }
  }
}
</style>
